import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import queryString from 'query-string'
import store from '@store/store.ts'
import { actions as selectableActions } from '@features/selectable/index.js'
import { getCurrentColorScheme } from './selectors/data/color_scheme_selectors.js'
import { LARGE } from '@constants/timeline_view_sizes.js'
import { changeAdVisibility } from '@actions/ad_actions.js'
import { LIST, TIMELINE } from '@constants/timeline_view_modes.js'
import { containers as listTimelineContainers } from '@features/list_timeline/index.js'
import { containers as classicHorizontalTimelineContainers } from '@features/classic_horizontal_timeline/index.ts'
import { changeCurrentColorScheme } from '@actions/color_scheme_actions.js'
import { parseColorScheme } from '@helpers/color_scheme_helpers.js'
import { ThemeContext } from '@base/ThemeContext.js'
import { hydrateCompleteTimelineFromDOMNode } from '@utils/hydrator.js'

const { ListTimelineContainer } = listTimelineContainers
const { HorizontalTimelineContainer } = classicHorizontalTimelineContainers

window.Timetoast.timelines = {
  ...window.Timetoast.timelines,
  embed: {
    init: function (options) {
      const { timelineId, environment, allowCustomColorScheme } = options.data.raw
      const { timelineData } = options.data.dom
      const targetDOMId = options.targets.timeline

      const namespace = 'embed'

      hydrateCompleteTimelineFromDOMNode(timelineData)

      const size = LARGE
      store.dispatch(
        selectableActions.initialize({
          namespace,
          scope: 'viewSize',
          options: [],
          value: size,
        })
      )
      store.dispatch(changeAdVisibility(false))

      const query = queryString.parse(window.location.search)

      // The view type
      // Note: query.mode is legacy, but has been out in the wild and used in embeds for a long time
      // mode could be timeline or list
      const viewType = query.mode || TIMELINE

      // the color scheme
      if (allowCustomColorScheme && query.colors && query.colors.length > 0) {
        const customColorScheme = parseColorScheme(query.colors)
        store.dispatch(changeCurrentColorScheme(customColorScheme))
      }
      const colorScheme = getCurrentColorScheme(store.getState())

      // output some information
      console.info(
        '%c Timelines powered by Timetoast https://www.timetoast.com ',
        'background: #5A00FF; color: #FFFFFF'
      )
      console.info(`Embed view: ${viewType}, Custom color schemes enabled: ${allowCustomColorScheme}`)

      let content = null
      switch (viewType) {
        case LIST:
          content = <ListTimelineContainer timelineId={timelineId} environment={environment} />
          break

        case TIMELINE:
          content = (
            <div className="embedded-horizontal-timeline">
              <HorizontalTimelineContainer timelineId={timelineId} namespace={namespace} />
            </div>
          )
          break
      }
      const root = createRoot(document.getElementById(targetDOMId))
      root.render(
        <Provider store={store}>
          <ThemeContext.Provider value={colorScheme}>{content}</ThemeContext.Provider>
        </Provider>
      )
    },
  },
}
